// @ts-nocheck
type Theme = {
  background0: string;
  background025: string;
  background05: string;
  background075: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
  color10: string;
  color11: string;
  color12: string;
  color13: string;
  color0: string;
  color025: string;
  color05: string;
  color075: string;
  background: string;
  backgroundHover: string;
  backgroundPress: string;
  backgroundFocus: string;
  borderColor: string;
  borderColorHover: string;
  borderColorPress: string;
  borderColorFocus: string;
  color: string;
  colorHover: string;
  colorPress: string;
  colorFocus: string;
  colorTransparent: string;
  placeholderColor: string;
  outlineColor: string;
  textSecondary: string;
  backgroundSecondary: string;
  backgroundTertiary: string;
  groupedPrimary: string;
  groupedSecondary: string;
  strokePrimary: string;
  cream1: string;
  cream2: string;
  cream3: string;
  cream4: string;
  cream5: string;
  cream6: string;
  cream7: string;
  cream8: string;
  cream9: string;
  cream10: string;
  cream11: string;
  cream12: string;
  cream13: string;
  gray1: string;
  gray2: string;
  gray3: string;
  gray4: string;
  gray5: string;
  gray6: string;
  gray7: string;
  gray8: string;
  gray9: string;
  gray10: string;
  gray11: string;
  gray12: string;
  gray13: string;
  green1: string;
  green2: string;
  green3: string;
  green4: string;
  green5: string;
  green6: string;
  green7: string;
  green8: string;
  green9: string;
  green10: string;
  green11: string;
  green12: string;
  green13: string;
  lightblue1: string;
  lightblue2: string;
  lightblue3: string;
  lightblue4: string;
  lightblue5: string;
  lightblue6: string;
  lightblue7: string;
  lightblue8: string;
  lightblue9: string;
  lightblue10: string;
  lightblue11: string;
  lightblue12: string;
  lightblue13: string;
  limegreen1: string;
  limegreen2: string;
  limegreen3: string;
  limegreen4: string;
  limegreen5: string;
  limegreen6: string;
  limegreen7: string;
  limegreen8: string;
  limegreen9: string;
  limegreen10: string;
  limegreen11: string;
  limegreen12: string;
  limegreen13: string;
  navy1: string;
  navy2: string;
  navy3: string;
  navy4: string;
  navy5: string;
  navy6: string;
  navy7: string;
  navy8: string;
  navy9: string;
  navy10: string;
  navy11: string;
  navy12: string;
  navy13: string;
  orange1: string;
  orange2: string;
  orange3: string;
  orange4: string;
  orange5: string;
  orange6: string;
  orange7: string;
  orange8: string;
  orange9: string;
  orange10: string;
  orange11: string;
  orange12: string;
  orange13: string;
  red1: string;
  red2: string;
  red3: string;
  red4: string;
  red5: string;
  red6: string;
  red7: string;
  red8: string;
  red9: string;
  red10: string;
  red11: string;
  red12: string;
  red13: string;
  shadowColor: string;
  shadowColorHover: string;
  shadowColorPress: string;
  shadowColorFocus: string;
  navy: string;
  lightblue: string;
  cream: string;
  limegreen: string;
  strokeSecondary: string;
  strokeTertiary: string;
  textTertiary: string;

}

function t(a: [number, number][]) {
  let res: Record<string,string> = {}
  for (const [ki, vi] of a) {
    res[ks[ki] as string] = colors[vi] as string
  }
  return res as Theme
}
export const colors = [
  'hsla(0, 0%, 100%, 0)',
  'hsla(0, 0%, 100%, 0.25)',
  'hsla(0, 0%, 100%, 0.5)',
  'hsla(0, 0%, 100%, 0.75)',
  'hsl(0, 0%, 100%)',
  'hsl(40, 60%, 99.02%)',
  'hsl(36, 55.56%, 96.47%)',
  'hsl(36, 50%, 96.08%)',
  'hsl(42, 29.41%, 93.33%)',
  'hsl(36.92, 11.3%, 77.45%)',
  'hsl(218.01, 10.4%, 62.38%)',
  'hsl(217.9, 20.15%, 47.65%)',
  'hsl(218.24, 43.54%, 33.24%)',
  'hsl(219.38, 100%, 18.82%)',
  'hsl(36, 2.56%, 38.24%)',
  'hsl(228, 61.64%, 14.31%)',
  'hsla(219.38, 100%, 18.82%, 0)',
  'hsla(219.38, 100%, 18.82%, 0.25)',
  'hsla(219.38, 100%, 18.82%, 0.5)',
  'hsla(219.38, 100%, 18.82%, 0.75)',
  'hsl(223.81, 0%, 100%)',
  'hsl(35.98, 55.7%, 99.6%)',
  'hsl(35.99, 55.67%, 98.98%)',
  'hsl(35.99, 55.64%, 98.23%)',
  'hsl(35.99, 55.6%, 97.39%)',
  'hsl(36, 22.32%, 90.03%)',
  'hsl(36, 14.64%, 83.69%)',
  'hsl(36, 11.28%, 77.45%)',
  'hsl(36.01, 7.63%, 65.3%)',
  'hsl(36.01, 6.22%, 57.04%)',
  'hsl(36.01, 1.79%, 48.38%)',
  'hsl(36.04, 7.67%, 26.52%)',
  'hsl(223.81, 0%, 98.71%)',
  'hsl(223.81, 0%, 96.69%)',
  'hsl(223.81, 0%, 94.28%)',
  'hsl(223.81, 0%, 91.57%)',
  'hsl(223.81, 0%, 88.63%)',
  'hsl(223.81, 0%, 82.78%)',
  'hsl(223.81, 0%, 77.01%)',
  'hsl(223.81, 0%, 71.32%)',
  'hsl(223.81, 0%, 60.2%)',
  'hsl(223.81, 0%, 52.62%)',
  'hsl(223.81, 0%, 44.21%)',
  'hsl(223.81, 0%, 24.44%)',
  'hsl(136.74, 86.72%, 98.03%)',
  'hsl(137.32, 85.98%, 94.88%)',
  'hsl(138.1, 85.17%, 90.94%)',
  'hsl(139.12, 84.37%, 86.27%)',
  'hsl(140.49, 83.67%, 80.78%)',
  'hsl(140.77, 70.06%, 73.76%)',
  'hsl(141.11, 60.58%, 67.19%)',
  'hsl(141.49, 54.35%, 60.68%)',
  'hsl(142.52, 47.08%, 48.55%)',
  'hsl(143.56, 58.97%, 40.26%)',
  'hsl(145.38, 20.72%, 39.02%)',
  'hsl(154.32, 100%, 7.32%)',
  'hsl(198.25, 100%, 98.36%)',
  'hsl(198.17, 100%, 95.77%)',
  'hsl(198.06, 100%, 92.59%)',
  'hsl(197.91, 100%, 88.9%)',
  'hsl(197.69, 100%, 84.71%)',
  'hsl(197.65, 81.32%, 78.57%)',
  'hsl(197.59, 68.54%, 72.62%)',
  'hsl(197.53, 60.36%, 66.74%)',
  'hsl(197.37, 47.47%, 55.42%)',
  'hsl(197.21, 45.32%, 47.71%)',
  'hsl(196.93, 17.13%, 41.59%)',
  'hsl(194.54, 100%, 17.67%)',
  'hsl(81.37, 80.34%, 98.06%)',
  'hsl(80.98, 79.85%, 95%)',
  'hsl(80.49, 79.31%, 91.25%)',
  'hsl(79.89, 78.76%, 86.9%)',
  'hsl(79.17, 78.26%, 81.96%)',
  'hsl(79.02, 62.98%, 74.46%)',
  'hsl(78.85, 53.39%, 67.56%)',
  'hsl(78.66, 47.22%, 60.75%)',
  'hsl(78.19, 40.45%, 48.36%)',
  'hsl(77.74, 50%, 40.06%)',
  'hsl(77.04, 16.19%, 41%)',
  'hsl(72.49, 100%, 9.43%)',
  'hsl(217.64, 28.4%, 90.23%)',
  'hsl(217.67, 27.55%, 75.29%)',
  'hsl(217.79, 26.38%, 57.84%)',
  'hsl(218.13, 39.03%, 38.91%)',
  'hsl(220.31, 100%, 18.76%)',
  'hsl(221.56, 100%, 18.52%)',
  'hsl(223.19, 100%, 18.46%)',
  'hsl(227.94, 100%, 18.08%)',
  'hsl(232.66, 100%, 17.99%)',
  'hsl(238.08, 95%, 6.81%)',
  'hsl(249.82, 100%, 10.51%)',
  'hsl(25.41, 98.66%, 97.62%)',
  'hsl(25.53, 97.04%, 93.85%)',
  'hsl(25.69, 95.18%, 89.23%)',
  'hsl(25.9, 93.19%, 83.89%)',
  'hsl(26.21, 91.15%, 77.84%)',
  'hsl(26.28, 82.85%, 72.28%)',
  'hsl(26.36, 74.38%, 66.83%)',
  'hsl(26.45, 68.27%, 61.43%)',
  'hsl(26.71, 56.23%, 50.89%)',
  'hsl(26.99, 64.42%, 43.64%)',
  'hsl(27.52, 24.99%, 36.97%)',
  'hsl(31.22, 100%, 14.55%)',
  'hsl(2.41, 100%, 97.74%)',
  'hsl(2.13, 100%, 94.09%)',
  'hsl(1.69, 100%, 89.48%)',
  'hsl(1.03, 97.78%, 84.05%)',
  'hsl(0, 91.15%, 77.84%)',
  'hsl(359.8, 90.11%, 74.56%)',
  'hsl(359.58, 83.91%, 70.72%)',
  'hsl(359.31, 79%, 66.88%)',
  'hsl(358.63, 65.23%, 58.15%)',
  'hsl(357.96, 57.5%, 51.87%)',
  'hsl(356.86, 26.63%, 33.91%)',
  'hsl(348.14, 100%, 21.78%)',
  'rgba(0,0,0,0.08)',
  'rgba(0,0,0,0.04)',
  '#002160',
  '#B1E8FF',
  '#FBF7F1',
  '#DEF5AD',
  '#EBE7E0',
  '#ADA8A0',
  'hsla(223.81, 0%, 100%, 0)',
  'hsla(223.81, 0%, 100%, 0.25)',
  'hsla(223.81, 0%, 100%, 0.5)',
  'hsla(223.81, 0%, 100%, 0.75)',
  'hsla(357.96, 57.5%, 51.87%, 0)',
  'hsla(357.96, 57.5%, 51.87%, 0.25)',
  'hsla(357.96, 57.5%, 51.87%, 0.5)',
  'hsla(357.96, 57.5%, 51.87%, 0.75)',
  'hsla(143.56, 58.97%, 40.26%, 0)',
  'hsla(143.56, 58.97%, 40.26%, 0.25)',
  'hsla(143.56, 58.97%, 40.26%, 0.5)',
  'hsla(143.56, 58.97%, 40.26%, 0.75)',
  'hsla(26.99, 64.42%, 43.64%, 0)',
  'hsla(26.99, 64.42%, 43.64%, 0.25)',
  'hsla(26.99, 64.42%, 43.64%, 0.5)',
  'hsla(26.99, 64.42%, 43.64%, 0.75)',
  'hsla(197.21, 45.32%, 47.71%, 0)',
  'hsla(197.21, 45.32%, 47.71%, 0.25)',
  'hsla(197.21, 45.32%, 47.71%, 0.5)',
  'hsla(197.21, 45.32%, 47.71%, 0.75)',
  'hsla(223.81, 0%, 52.62%, 0)',
  'hsla(223.81, 0%, 52.62%, 0.25)',
  'hsla(223.81, 0%, 52.62%, 0.5)',
  'hsla(223.81, 0%, 52.62%, 0.75)',
  '#FAF9F8',
  '#F5F4F1',
  '#010222',
  '#7E7C79',
  '#98938B',
  '#FFFFFF',
  '#D5CFC9',
  '#0E173B',
  '#538227',
  '#EFFAD6',
  '#EB6B6B',
  '#B84A4A',
  '#FFEEED',
  '#FCA92C',
  '#C65E14',
  '#FFEFDE',
]

const ks = [
'background0',
'background025',
'background05',
'background075',
'color1',
'color2',
'color3',
'color4',
'color5',
'color6',
'color7',
'color8',
'color9',
'color10',
'color11',
'color12',
'color13',
'color0',
'color025',
'color05',
'color075',
'background',
'backgroundHover',
'backgroundPress',
'backgroundFocus',
'borderColor',
'borderColorHover',
'borderColorPress',
'borderColorFocus',
'color',
'colorHover',
'colorPress',
'colorFocus',
'colorTransparent',
'placeholderColor',
'outlineColor',
'textSecondary',
'backgroundSecondary',
'backgroundTertiary',
'groupedPrimary',
'groupedSecondary',
'strokePrimary',
'cream1',
'cream2',
'cream3',
'cream4',
'cream5',
'cream6',
'cream7',
'cream8',
'cream9',
'cream10',
'cream11',
'cream12',
'cream13',
'gray1',
'gray2',
'gray3',
'gray4',
'gray5',
'gray6',
'gray7',
'gray8',
'gray9',
'gray10',
'gray11',
'gray12',
'gray13',
'green1',
'green2',
'green3',
'green4',
'green5',
'green6',
'green7',
'green8',
'green9',
'green10',
'green11',
'green12',
'green13',
'lightblue1',
'lightblue2',
'lightblue3',
'lightblue4',
'lightblue5',
'lightblue6',
'lightblue7',
'lightblue8',
'lightblue9',
'lightblue10',
'lightblue11',
'lightblue12',
'lightblue13',
'limegreen1',
'limegreen2',
'limegreen3',
'limegreen4',
'limegreen5',
'limegreen6',
'limegreen7',
'limegreen8',
'limegreen9',
'limegreen10',
'limegreen11',
'limegreen12',
'limegreen13',
'navy1',
'navy2',
'navy3',
'navy4',
'navy5',
'navy6',
'navy7',
'navy8',
'navy9',
'navy10',
'navy11',
'navy12',
'navy13',
'orange1',
'orange2',
'orange3',
'orange4',
'orange5',
'orange6',
'orange7',
'orange8',
'orange9',
'orange10',
'orange11',
'orange12',
'orange13',
'red1',
'red2',
'red3',
'red4',
'red5',
'red6',
'red7',
'red8',
'red9',
'red10',
'red11',
'red12',
'red13',
'shadowColor',
'shadowColorHover',
'shadowColorPress',
'shadowColorFocus',
'navy',
'lightblue',
'cream',
'limegreen',
'strokeSecondary',
'strokeTertiary',
'textTertiary']


const n1 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 9],[26, 13],[27, 13],[28, 13],[29, 15],[30, 13],[31, 15],[32, 13],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9],[42, 20],[43, 21],[44, 22],[45, 23],[46, 24],[47, 6],[48, 25],[49, 26],[50, 27],[51, 28],[52, 29],[53, 30],[54, 31],[55, 20],[56, 32],[57, 33],[58, 34],[59, 35],[60, 36],[61, 37],[62, 38],[63, 39],[64, 40],[65, 41],[66, 42],[67, 43],[68, 20],[69, 44],[70, 45],[71, 46],[72, 47],[73, 48],[74, 49],[75, 50],[76, 51],[77, 52],[78, 53],[79, 54],[80, 55],[81, 20],[82, 56],[83, 57],[84, 58],[85, 59],[86, 60],[87, 61],[88, 62],[89, 63],[90, 64],[91, 65],[92, 66],[93, 67],[94, 20],[95, 68],[96, 69],[97, 70],[98, 71],[99, 72],[100, 73],[101, 74],[102, 75],[103, 76],[104, 77],[105, 78],[106, 79],[107, 20],[108, 80],[109, 81],[110, 82],[111, 83],[112, 13],[113, 84],[114, 85],[115, 86],[116, 87],[117, 88],[118, 89],[119, 90],[120, 20],[121, 91],[122, 92],[123, 93],[124, 94],[125, 95],[126, 96],[127, 97],[128, 98],[129, 99],[130, 100],[131, 101],[132, 102],[133, 20],[134, 103],[135, 104],[136, 105],[137, 106],[138, 107],[139, 108],[140, 109],[141, 110],[142, 111],[143, 112],[144, 113],[145, 114],[146, 115],[147, 115],[148, 116],[149, 116],[150, 117],[151, 118],[152, 119],[153, 120],[154, 121],[155, 119],[156, 122]])
const n2 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 4],[22, 3],[23, 6],[24, 6],[25, 9],[26, 13],[27, 13],[28, 13],[29, 15],[30, 13],[31, 15],[32, 13],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n3 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 103],[6, 104],[7, 105],[8, 106],[9, 107],[10, 108],[11, 109],[12, 110],[13, 111],[14, 112],[15, 113],[16, 114],[17, 127],[18, 128],[19, 129],[20, 130],[21, 20],[22, 126],[23, 103],[24, 103],[25, 113],[26, 114],[27, 114],[28, 114],[29, 114],[30, 113],[31, 114],[32, 113],[33, 128],[34, 113],[35, 129],[36, 113]])
const n4 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 44],[6, 45],[7, 46],[8, 47],[9, 48],[10, 49],[11, 50],[12, 51],[13, 52],[14, 53],[15, 54],[16, 55],[17, 131],[18, 132],[19, 133],[20, 134],[21, 20],[22, 126],[23, 44],[24, 44],[25, 54],[26, 55],[27, 55],[28, 55],[29, 55],[30, 54],[31, 55],[32, 54],[33, 132],[34, 54],[35, 133],[36, 54]])
const n5 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 91],[6, 92],[7, 93],[8, 94],[9, 95],[10, 96],[11, 97],[12, 98],[13, 99],[14, 100],[15, 101],[16, 102],[17, 135],[18, 136],[19, 137],[20, 138],[21, 20],[22, 126],[23, 91],[24, 91],[25, 101],[26, 102],[27, 102],[28, 102],[29, 102],[30, 101],[31, 102],[32, 101],[33, 136],[34, 101],[35, 137],[36, 101]])
const n6 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 56],[6, 57],[7, 58],[8, 59],[9, 60],[10, 61],[11, 62],[12, 63],[13, 64],[14, 65],[15, 66],[16, 67],[17, 139],[18, 140],[19, 141],[20, 142],[21, 20],[22, 126],[23, 56],[24, 56],[25, 66],[26, 67],[27, 67],[28, 67],[29, 67],[30, 66],[31, 67],[32, 66],[33, 140],[34, 66],[35, 141],[36, 66]])
const n7 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 32],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 41],[15, 42],[16, 43],[17, 143],[18, 144],[19, 145],[20, 146],[21, 20],[22, 126],[23, 32],[24, 32],[25, 42],[26, 43],[27, 43],[28, 43],[29, 43],[30, 42],[31, 43],[32, 42],[33, 144],[34, 42],[35, 145],[36, 42]])
const n8 = t([[29, 14],[30, 13],[31, 14],[32, 13]])
const n9 = t([[29, 13],[30, 13],[31, 13],[32, 13],[25, 13],[26, 13],[28, 13],[27, 13]])
const n10 = t([[29, 112],[30, 111],[31, 112],[32, 111],[25, 111],[26, 111],[28, 111],[27, 111]])
const n11 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 13],[15, 14],[16, 15],[17, 16],[18, 17],[19, 18],[20, 19],[21, 13],[22, 11],[23, 13],[24, 11],[25, 13],[26, 13],[27, 11],[28, 12],[29, 4],[30, 3],[31, 6],[32, 6],[33, 17],[34, 14],[35, 18],[36, 14],[37, 5],[38, 6],[39, 7],[40, 8],[41, 9]])
const n12 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 103],[6, 104],[7, 105],[8, 106],[9, 107],[10, 108],[11, 109],[12, 110],[13, 111],[14, 112],[15, 113],[16, 114],[17, 127],[18, 128],[19, 129],[20, 130],[21, 112],[22, 109],[23, 112],[24, 109],[25, 112],[26, 111],[27, 109],[28, 110],[29, 20],[30, 126],[31, 104],[32, 104],[33, 128],[34, 113],[35, 129],[36, 113],[37, 103],[38, 104],[39, 105],[40, 106],[41, 107]])
const n13 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 44],[6, 45],[7, 46],[8, 47],[9, 48],[10, 49],[11, 50],[12, 51],[13, 52],[14, 53],[15, 54],[16, 55],[17, 131],[18, 132],[19, 133],[20, 134],[21, 53],[22, 50],[23, 53],[24, 50],[25, 53],[26, 52],[27, 50],[28, 51],[29, 20],[30, 126],[31, 45],[32, 45],[33, 132],[34, 54],[35, 133],[36, 54],[37, 44],[38, 45],[39, 46],[40, 47],[41, 48]])
const n14 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 91],[6, 92],[7, 93],[8, 94],[9, 95],[10, 96],[11, 97],[12, 98],[13, 99],[14, 100],[15, 101],[16, 102],[17, 135],[18, 136],[19, 137],[20, 138],[21, 100],[22, 97],[23, 100],[24, 97],[25, 100],[26, 99],[27, 97],[28, 98],[29, 20],[30, 126],[31, 92],[32, 92],[33, 136],[34, 101],[35, 137],[36, 101],[37, 91],[38, 92],[39, 93],[40, 94],[41, 95]])
const n15 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 56],[6, 57],[7, 58],[8, 59],[9, 60],[10, 61],[11, 62],[12, 63],[13, 64],[14, 65],[15, 66],[16, 67],[17, 139],[18, 140],[19, 141],[20, 142],[21, 65],[22, 62],[23, 65],[24, 62],[25, 65],[26, 64],[27, 62],[28, 63],[29, 20],[30, 126],[31, 57],[32, 57],[33, 140],[34, 66],[35, 141],[36, 66],[37, 56],[38, 57],[39, 58],[40, 59],[41, 60]])
const n16 = t([[0, 123],[1, 124],[2, 125],[3, 126],[4, 20],[5, 32],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 41],[15, 42],[16, 43],[17, 143],[18, 144],[19, 145],[20, 146],[21, 41],[22, 38],[23, 41],[24, 38],[25, 41],[26, 40],[27, 38],[28, 39],[29, 20],[30, 126],[31, 33],[32, 33],[33, 144],[34, 42],[35, 145],[36, 42],[37, 32],[38, 33],[39, 34],[40, 35],[41, 36]])
const n17 = t([[21, 147],[22, 148],[23, 148],[24, 148],[29, 149],[30, 149],[31, 150],[32, 149],[25, 121],[26, 121],[27, 121],[28, 117],[34, 151],[-1, 147],[-1, 148],[-1, 152],[-1, 149],[36, 150],[-1, 151],[-1, 121],[-1, 153],[-1, 117],[-1, 154],[-1, 120],[-1, 155],[-1, 156],[-1, 157],[-1, 158],[-1, 159],[-1, 160],[-1, 161],[-1, 162]])

type ThemeNames =
 | 'light'
 | 'light_granted'
 | 'light_red'
 | 'light_green'
 | 'light_orange'
 | 'light_lightblue'
 | 'light_gray'
 | 'light_alt1'
 | 'light_alt2'
 | 'light_red_alt2'
 | 'v2'

export const themes: Record<ThemeNames, Theme> = {
  light: n1,
  light_granted: n2,
  light_red: n3,
  light_green: n4,
  light_orange: n5,
  light_lightblue: n6,
  light_gray: n7,
  light_alt1: n8,
  light_alt2: n9,
  light_red_alt2: n10,
  light_Button: n11,
  light_granted_Button: n11,
  light_red_Button: n12,
  light_green_Button: n13,
  light_orange_Button: n14,
  light_lightblue_Button: n15,
  light_gray_Button: n16,
  v2: n17,
}
